// extracted by mini-css-extract-plugin
export var dropdownButton = "_48-0";
export var fullWidthDropdownButton = "_48-1";
export var icon = "_48-3";
export var iconPlaceholder = "_48-2";
export var menuItemRow = "_48-8";
export var separator = "_48-d";
export var shortcutContainer = "_48-7";
export var shortcutIconLg = "_48-6";
export var shortcutIconMd = "_48-5";
export var shortcutIconSm = "_48-4";
export var submenuChevron = "_48-c";
export var submenuDropdown = "_48-9";
export var submenuTriggerRow = "_48-a";
export var submenuTriggerRowOpen = "_48-b";